import React from 'react'
import { observer } from 'mobx-react-lite'
import { Col, Row } from 'antd'
import { ReportsStore } from 'store/reports.store'
import { Divider } from 'shared/components/divider/Divider'
import {
  DashboardHeader,
  DashboardHeaderAnnotation,
  DashboardHeaderTitle,
  DashboardHeaderValue,
} from '../styled'

export const MonthConsumptionFeature = observer(() => (
  <div>
    <Row gutter={24}>
      <Col xs={24} md={12} lg={6}>
        <DashboardHeader>
          <DashboardHeaderTitle>Quotes Profit</DashboardHeaderTitle>
          <DashboardHeaderValue>{ReportsStore.incomeForMonthByQuotes}</DashboardHeaderValue>
        </DashboardHeader>
      </Col>

      <Col xs={24} md={12} lg={6}>
        <DashboardHeader>
          <DashboardHeaderTitle>Total sold</DashboardHeaderTitle>
          <DashboardHeaderValue>{ReportsStore.totalSold}</DashboardHeaderValue>
        </DashboardHeader>
      </Col>

      <Col xs={24} md={12} lg={6}>
        <DashboardHeader>
          <DashboardHeaderTitle>Total Profit</DashboardHeaderTitle>
          <DashboardHeaderValue>{ReportsStore.totalProfit}</DashboardHeaderValue>
        </DashboardHeader>
      </Col>

      <Col xs={24} md={12} lg={6}>
        <DashboardHeader>
          <DashboardHeaderTitle>Total New Members</DashboardHeaderTitle>
          <DashboardHeaderValue>{ReportsStore.todayRegistrationsCount}</DashboardHeaderValue>
        </DashboardHeader>
      </Col>
    </Row>

    <Row gutter={24}>
      <Col xs={24} md={12} lg={6}>
        <DashboardHeader>
          <DashboardHeaderTitle>
            <div>
              <span>{ReportsStore.topConsumptionMember.member?.firstName} </span>
              <span>{ReportsStore.topConsumptionMember.member?.lastName}</span>
            </div>
          </DashboardHeaderTitle>
          <DashboardHeaderValue>
            {ReportsStore.topConsumptionMember.consumption}
          </DashboardHeaderValue>
          <DashboardHeaderAnnotation>Top Consumption gram</DashboardHeaderAnnotation>
        </DashboardHeader>
      </Col>
    </Row>
    <Divider />
    <h2>Consumption by Category</h2>

    <Row gutter={24}>
      {ReportsStore.consumptionByCategory.map((i) => (
        <Col xs={24} md={12} lg={6} key={i.category?.id}>
          <DashboardHeader>
            <DashboardHeaderTitle>{i.category?.title}</DashboardHeaderTitle>
            <DashboardHeaderValue>{i.sum}</DashboardHeaderValue>
            <DashboardHeaderAnnotation>Quantity: {i.quantity}</DashboardHeaderAnnotation>
          </DashboardHeader>
        </Col>
      ))}
    </Row>
  </div>
))
